// extracted by mini-css-extract-plugin
export default {"main":"BirthdayManager_main__eiOup","headline":"BirthdayManager_headline__k8bAH"};